<div>  
  <form [formGroup]="contactUsForm" autocomplete="off">
    <div class="row">
      <div class="col-sm-1 col-md-1 col-lg-2"></div>
      <div class="col-sm-10 col-md-10 col-lg-8 paddingZero">
        <div class="row">
          <div class="col-sm-12 col-md-12">
            <span>
              {{contactUsTxt.headingTextLbl?contactUsTxt.headingTextLbl:contacts.headingTextLbl}}
            </span>
          </div>
          <br />
          <br />
          <div class="col-sm-6">
            <div class="form-group">
              <label class="lblCls">
                {{contactUsTxt.firstNameLbl?contactUsTxt.firstNameLbl:contacts.firstNameLbl}}<span class="requiredField">*</span>
              </label>
              <input type="text" kendoTextBox class="kendoInput" name="firstName" formControlName="firstName" [ngClass]="{'borderRed':contacts.isEmptyFirstName && contacts.isSubmitted}"
                     (blur)="validateContactUsForm()" />
            </div>
            <div class="form-group">
              <label class="lblCls">
                {{contactUsTxt.lastNameLbl?contactUsTxt.lastNameLbl:contacts.lastNameLbl}}
              </label>
              <input type="text" kendoTextBox class="kendoInput" name="lastName" formControlName="lastName" />
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group">
              <label class="lblCls">
                {{contactUsTxt.customerNumberLbl?contactUsTxt.customerNumberLbl:contacts.customerNumberLbl}}
              </label>
              <input type="text" kendoTextBox class="kendoInput" name="customerNumber" formControlName="customerNumber" />
            </div>
            <div class="form-group">
              <label class="lblCls">
                {{contactUsTxt.commentsLbl?contactUsTxt.commentsLbl:contacts.commentsLbl}}
              </label>
              <textarea kendoTextArea class="kendoInput"
                        formControlName="comments"></textarea>
            </div>
          </div>
          <div class="col-sm-12 col-md-12">
            <h5> {{contactUsTxt.contactInfoLbl?contactUsTxt.contactInfoLbl:contacts.contactInfoLbl}}</h5>
          </div>
          <br />
          <br />
          <div class="col-sm-6">
            <div class="form-group">
              <label class="lblCls">
                {{contactUsTxt.phoneNumberLbl?contactUsTxt.phoneNumberLbl:contacts.phoneNumberLbl}}<span class="requiredField">*</span>
              </label>
              <kendo-numerictextbox class="kendoInput" name="phoneNumber" formControlName="phoneNumber" [decimals]="0"
                                    [format]="'#'" [spinners]="false" [ngClass]="{'borderRed':contacts.isEmptyPhoneNumber && contacts.isSubmitted}"
                                    (blur)="validateContactUsForm()"></kendo-numerictextbox>
              <span title="{{contactUsTxt.invalidPhoneLbl?contactUsTxt.invalidPhoneLbl:contacts.invalidPhoneLbl}}"
                    *ngIf="contacts.isInvalidPhoneNumber" kendoTooltip
                    class="k-icon k-i-information k-i-info spanInfoIconCls"></span>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group">
              <label class="lblCls">
                {{contactUsTxt.emailLbl?contactUsTxt.emailLbl:contacts.emailLbl}}<span class="requiredField">*</span>
              </label>
              <input type="text" kendoTextBox class="kendoInput" name="email" formControlName="email" [ngClass]="{'borderRed':(contacts.isEmptyEmail || contacts.isInvalidEmail) && contacts.isSubmitted}"
                     (blur)="emailLeave()" />
              <span title="{{contactUsTxt.invalidEmailLbl?contactUsTxt.invalidEmailLbl:contacts.invalidEmailLbl}}" *ngIf="contacts.isInvalidEmail" kendoTooltip
                    class="k-icon k-i-information k-i-info spanInfoIconCls"></span>
            </div>

          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <div class="d-flex justify-content-center align-items-center flex-xs-column flex-sm-column flex-md-row flex-lg-row flex-xl-row">
              <button kendoButton [disabled]="saveInProcess" class=" m-3 btn k-button"
                      (click)="resetContactUsForm()">
                {{contactUsTxt.cancelLbl?contactUsTxt.cancelLbl:contacts.cancelLbl}}
              </button>
              <button kendoButton [disabled]="saveInProcess" class=" m-3 btn btn-success"
                      (click)="save()">
                {{contactUsTxt.saveLbl?contactUsTxt.saveLbl:contacts.saveLbl}}<kendo-loader *ngIf="saveInProcess" style="color:blue"></kendo-loader>
              </button>

            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-1 col-md-1 col-lg-2"></div>
    </div>

  </form>
</div>
